import { useState } from 'react';
import { useSelector } from 'react-redux';
import { getAppUser } from '../../app/appSelectors';
import UserStatusInfo from './UserStatusInfo';
import { getUsesStatusesSelector } from '../../app/userSelectors';

function UserStatuses() {
    const user = useSelector(getAppUser);
    const [selectedStatus, setSelectedStatus] = useState(user.user_status);
    const userStatuses = useSelector(getUsesStatusesSelector);

    return <>
        <UserStatusInfo
            onChangeStatus={setSelectedStatus}
            selectedStatus={selectedStatus}
            userStatuses={userStatuses}
        />
    </>;
}

export default UserStatuses;
